import { Config } from "@/models/Config";
import configData from "../data/config.json";

const config: Config = configData as Config;

export default {
  loginUrl: config.serverUrl + "login",
  logoutUrl: config.serverUrl + "Authentication/LogoutFromFrontClient",
  editBannerUrl: config.serverUrl + "Banner/Edit",
  campaignAppDataUrl: config.serverUrl + "Channels/_AppData",
  campaignAssetsDataUrl: config.serverUrl + "Channels/_AssetsData",
  clientAutoCompletePropertiesUrl: config.serverUrl + "Channels/_AutoCompleteProperties",
  campaignTagsDataUrl: config.serverUrl + "Channels/_ChannelTagsData",
  campaignCostsDataUrl: config.serverUrl + "Channels/_CostsData",
  campaignCRMDataUrl: config.serverUrl + "Channels/_CRMData",
  campaignFacebookDataUrl: config.serverUrl + "Channels/_FacebookData",
  campaignFinishDataUrl: config.serverUrl + "Channels/_FinishData",
  campaignGoalsDataUrl: config.serverUrl + "Channels/_GoalsData",
  campaignGoogleDataUrl: config.serverUrl + "Channels/_GoogleData",
  campaignPhonesDataUrl: config.serverUrl + "Channels/_PhonesData",
  campaignProjectsDataUrl: config.serverUrl + "Channels/_ProjectPerformanceData",
  saveCampaignAppUrl: config.serverUrl + "Channels/_SaveAppFromBody",
  saveCampaignAssetsUrl: config.serverUrl + "Channels/_SaveAssetsFromBody",
  saveCampaignTagsUrl: config.serverUrl + "Channels/_SaveChannelTagsFromBody",
  saveCampaignCostUrl: config.serverUrl + "Channels/_SaveCostFromBody",
  saveCampaignCRMUrl: config.serverUrl + "Channels/_SaveCRMFromBody",
  saveCampaignFacebookUrl: config.serverUrl + "Channels/_SaveFacebookFromBody",
  saveCampaignGeneralInfoUrl: config.serverUrl + "Channels/_SaveGeneralInfoFromBody",
  saveCampaignGoalsUrl: config.serverUrl + "Channels/_SaveGoalsFromBody",
  saveCampaignGoogleUrl: config.serverUrl + "Channels/_SaveGoogleFromBody",
  saveCampaignMetadataTypeUrl: config.serverUrl + "Channels/_SaveMetadataTypeFromBody",
  campaignSavePhonesUrl: config.serverUrl + "Channels/_SavePhonesFromBody",
  saveCampaignProjectsUrl: config.serverUrl + "Channels/_SaveProjectPerformanceFromBody",
  saveCampaignWhatsappPhonesUrl: config.serverUrl + "Channels/_SaveWhatsAppPhoneFromBody",
  campaignSetActiveUrl: config.serverUrl + "Channels/_SetActiveFromBody",
  campaignWhatsAppPhonesDataUrl: config.serverUrl + "Channels/_WhatsAppPhonesData",
  campaignsStatisticByDateUrl: config.serverUrl + "Channels/CampaignsStatisticByDate",
  changeDefaultCampaignAssetUrl: config.serverUrl + "Channels/ChangeDefaultChannelAsset",
  campaignAssetsUrl: config.serverUrl + "Channels/ChannelAssets_Read",
  campaignsUrl: config.serverUrl + "Channels/Channels_Read",
  campaignsWithStatsUrl: config.serverUrl + "Channels/CampaignsStatistic",
  campaignAdGroups: config.serverUrl + "Channels/ChannelsAdGroups_Read",
  campaignKeywords: config.serverUrl + "Channels/ChannelsAdGroupsAdDetailKeywords_Read",
  campaignAds: config.serverUrl + "Channels/ChannelsAdGroupsDetail_Read",
  campaignCheckPhonesUrl: config.serverUrl + "Channels/CheckPhones",
  deleteCampaignUrl: config.serverUrl + "Channels/DeleteChannel",
  exportCampaignsToExcelUrl: config.serverUrl + "Channels/ExportToExcel",
  campaignUrl: config.serverUrl + "Channels/GetCampaign",
  campaignsPageDataUrl: config.serverUrl + "Channels/GetCampaignsPageData",
  getAdPreviewDataUrl: config.serverUrl + "Channels/GetAdPreviewData",
  campaignProjectListUrl: config.serverUrl + "Channels/ProjectList",
  campaignProjectPagesListUrl: config.serverUrl + "Channels/ProjectPagesList",
  campaignRenewPhoneUrl: config.serverUrl + "Channels/RenewPhoneFromBody",
  campaignSendMessageUrl: config.serverUrl + "Channels/SendMessage",
  campaignToggleActiveUrl: config.serverUrl + "Channels/ToggleEnabled",
  campaignTogglePhoneStateUrl: config.serverUrl + "Channels/TogglePhoneStateFromBody",
  addNoteUrl: config.serverUrl + "ContactForms/_AddNote",
  deleteNoteUrl: config.serverUrl + "ContactForms/_DeleteNote",
  deleteLeadUrl: config.serverUrl + "ContactForms/Delete",
  updateLeadUrl: config.serverUrl + "ContactForms/Edit",
  updateLeadClientUrl: config.serverUrl + "ContactForms/EditLeadClient",
  exportLeadsToExcelUrl: config.serverUrl + "ContactForms/ExportToExcel",
  exportLeadsToExcelToMailUrl: config.serverUrl + "ContactForms/ExportExcelToMail",
  leadUrl: config.serverUrl + "ContactForms/GetLead",
  leadClientUrl: config.serverUrl + "ContactForms/GetLeadClient",
  leadsPageDataUrl: config.serverUrl + "ContactForms/GetLeadsPageData",
  leadHistoryUrl: config.serverUrl + "ContactForms/Lead_History",
  contactFormsUrl: config.serverUrl + "ContactForms/Leads_Read",
  leadsStatisticCallsByDateUrl: config.serverUrl + "ContactForms/LeadsStatistic_CallsByDate",
  leadsStatisticChannelMetadataTypeUrl: config.serverUrl + "ContactForms/LeadsStatistic_ChannelMetadataType",
  leadsStatisticDealMeetingsLeadsUrl: config.serverUrl + "ContactForms/LeadsStatistic_DealMeetingsLeads",
  leadsStatisticByAdditionalStatusUrl: config.serverUrl + "ContactForms/LeadsStatistic_LeadsByAdditionalStatus",
  leadsStatisticByCallStatusUrl: config.serverUrl + "ContactForms/LeadsStatistic_LeadsByCallStatus",
  leadsStatisticByCampaignsUrl: config.serverUrl + "ContactForms/LeadsStatistic_LeadsByCampaigns",
  leadsStatisticByPhoneAndFormsUrl: config.serverUrl + "ContactForms/LeadsStatistic_LeadsByPhoneAndForms",
  leadsStatisticBySaleStatusUrl: config.serverUrl + "ContactForms/LeadsStatistic_LeadsBySaleStatus",
  additionalStatusesUrl: config.serverUrl + "ContactForms/SaleStatusList_Read",
  assigneesUrl: config.serverUrl + "ContactForms/Salesmans_Read",
  checkPhonePopupUrl: config.serverUrl + "ContactForms/CheckPhonePopup",
  setHidePopupCookieUrl: config.serverUrl + "ContactForms/SetHidePhonePopupCookie",
  setLanguageUrl: config.serverUrl + "Dashboard/SetLanguage",
  explanationPopupUrl: config.serverUrl + "ExplanationModule/GetPopup",
  explanationSaveImageFile: config.serverUrl + "ExplanationModule/SaveImageFile",
  explanationSendEmailUrl: config.serverUrl + "ExplanationModule/SendEmail",
  explanationSendAlgoliaPost: config.serverUrl + "ExplanationModule/AlgoliaPost",
  editExternalServiceUrl: config.serverUrl + "ExternalServices/Edit",
  facebookCheckChannelCampaignsUrl: config.serverUrl + "Facebook/CheckChannelCampaigns",
  facebookCheckTokenUrl: config.serverUrl + "Facebook/CheckToken",
  facebookClearChannelCampaignsUrl: config.serverUrl + "Facebook/ClearChannelCampaigns",
  facebookCampaignUrl: config.serverUrl + "Facebook/GetFacebookCampaign",
  facebookConnectDataUrl: config.serverUrl + "Facebook/GetFacebookConnectData",
  facebookPageUrl: config.serverUrl + "Facebook/Index",
  facebookLoginChannelCampaignsUrl: config.serverUrl + "Facebook/LoginChannelCampaigns",
  facebookLoginCustomerUrl: config.serverUrl + "Facebook/LoginFacebookCustomer",
  facebookRepairTokenUrl: config.serverUrl + "Facebook/RepairToken",
  facebookSendConnectMessageUrl: config.serverUrl + "Facebook/SendConnectMessage",
  outbrainLoginCustomerUrl: config.serverUrl + "Outbrain/LoginOutbrainAccount",
  outbrainConnectDataUrl: config.serverUrl + "Outbrain/GetOutbrainConnectData",
  outbrainSendConnectMessageUrl: config.serverUrl + "Outbrain/SendConnectMessage",
  outbrainPageUrl: config.serverUrl + "Outbrain/Index",
  tiktokLoginCustomerUrl: config.serverUrl + "TikTok/LoginTikTokAccount",
  tiktokConnectDataUrl: config.serverUrl + "TikTok/GetTikTokConnectData",
  tiktokSendConnectMessageUrl: config.serverUrl + "TikTok/SendConnectMessage",
  tiktokPageUrl: config.serverUrl + "TikTok/Index",
  googleCampaignUrl: config.serverUrl + "Google/GetGoogleCampaign",
  googleCheckChannelCampaignsUrl: config.serverUrl + "Google/CheckChannelCampaigns",
  googleCheckTokenUrl: config.serverUrl + "Google/CheckToken",
  googleClearChannelCampaignsUrl: config.serverUrl + "Google/ClearChannelCampaigns",
  googleConnectCampaignUrl: config.serverUrl + "Google/ConnectCampaign",
  googleLoginCustomerUrl: config.serverUrl + "Google/ConnectGoogleCustomer",
  googleConnectDataUrl: config.serverUrl + "Google/GetGoogleConnectData",
  googlePageUrl: config.serverUrl + "Google/Index",
  googleRepairTokenUrl: config.serverUrl + "Google/RepairToken",
  googleSendConnectMessageUrl: config.serverUrl + "Google/SendConnectMessage",
  tableSettingsUrl: config.serverUrl + "KendoGrid/GetTableSettings",
  saveTableSettingsUrl: config.serverUrl + "KendoGrid/SaveGridState",
  editLandPageUrl: config.serverUrl + "LandPages/Edit",
  adGroupsUrl: config.serverUrl + "MultiSelect/AdGroupsByChannel",
  adTitlesUrl: config.serverUrl + "MultiSelect/AdTitles",
  assetsUrl: config.serverUrl + "MultiSelect/Assets",
  channelsUrl: config.serverUrl + "MultiSelect/Channels",
  clientsUrl: config.serverUrl + "MultiSelect/Clients",
  projectsUrl: config.serverUrl + "MultiSelect/Commitments",
  tagsUrl: config.serverUrl + "MultiSelect/Tags",
  phonesChannelsUrl: config.serverUrl + "Phones/Channels",
  updatePhoneUrl: config.serverUrl + "Phones/EditFromBody",
  phonesPageDataUrl: config.serverUrl + "Phones/GetPhonesPageData",
  phonesPromptsUrl: config.serverUrl + "Phones/GetPromtsList",
  phonesUrl: config.serverUrl + "Phones/Phones_Read",
  releasePhoneUrl: config.serverUrl + "Phones/ReleaseMaskyooPhone",
  uploadAudioFilesUrl: config.serverUrl + "Phones/UploadAudioFiles",
  editAssetUrl: config.serverUrl + "Properties/Edit",
  editSiteUrl: config.serverUrl + "Sites/Edit",
  tagsForCampaignUrl: config.serverUrl + "Tags/TagsForChannel_Read",
  tagsForCampaignUpdateUrl: config.serverUrl + "Tags/TagsForChannel_UpdateFromBody",
  userDataUrl: config.serverUrl + "Users/GetUserData",

  maxIntValue: 2147483647,

  superAdminUserRole: "Super admin",
  agencyAdminUserRole: "Agency admin",
  leadViewerUserRole: "Lead viewer",
  checklistInProcessUserRole: "Checklist in process",
  packageCRMUserRole: "PackageCRM",
  packageFixerUserRole: "PackageFixer",
  packageFreeUserRole: "PackageFree",
};
